import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    return value.toLowerCase().replace(/\b\w/g, match => match.toUpperCase());
  }
}
